import { createAction, props } from '@ngrx/store';
import { ObjektId } from '@models/objekt-id';
import { IdentitaetPruefenResult } from 'app/core/services/api-client';

export const showCollisions = createAction(
  '[Merge] Show collisions',
  props<{ data: [ObjektId, boolean] }>()
);

export const showCollisionsSuccess = createAction(
  '[Merge] Show collisions (Success)',
  props<{ result: IdentitaetPruefenResult }>()
);

export const showCollisionsError = createAction(
  '[Merge] Show collisions Error (Error)'
);

export const merge = createAction(
  '[Merge] Merge',
  props<{ additionalId: number | null }>()
);

export const mergeSuccess = createAction(
  '[Merge] Merge (Success)'
);

export const mergeFailed = createAction(
  '[Merge] Merge (Failed)'
);
